// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactI18next from "react-i18next";
import * as TranslationVariants$LiveRoom from "../TranslationVariants.bs.js";

function tWithVariant(h, text) {
  return h.t(TranslationVariants$LiveRoom.tToJs(text));
}

function t2WithVariant(h, text) {
  var partial_arg = TranslationVariants$LiveRoom.tToJs(text);
  return function (param) {
    return h.t(partial_arg, param);
  };
}

var Internal = {
  tWithVariant: tWithVariant,
  t2WithVariant: t2WithVariant
};

function useTranslation(param) {
  var translate = ReactI18next.useTranslation();
  return {
          t: (function (param) {
              return translate.t(TranslationVariants$LiveRoom.tToJs(param));
            }),
          t2: (function (param) {
              return t2WithVariant(translate, param);
            }),
          i18n: translate.i18n
        };
}

var Trans = {};

var I18nextProvider = {};

export {
  Internal ,
  useTranslation ,
  Trans ,
  I18nextProvider ,
}
/* react-i18next Not a pure module */
